import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ConfigProvider, theme } from 'antd';
import "animate.css/animate.compat.css"
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider
        theme={{
            algorithm:theme.darkAlgorithm,
            components: {
                Timeline: {
                   dotBg:"transparent"
                },
            },
        }}
        
    >
        <App/>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
